export const REFRESH_TOKEN_PARAM = "hash";
export const phoneKey = "phone";
export const emailKey = "email";
export const keyByLoginModeHash = {
  sms: phoneKey,
  email: emailKey,
};
